import { Territory } from "../constants/territory.enum";

//* They actually use USD instead of AUD as told by business
export function getCurrency(territory: string) {
    if(territory === Territory.AUSTRALIA) {
        return 'USD';
    }

    return 'GBP';
}